<div class="dialog-container">
  <div>
    <div class="title-holder align-center">
      <h1 class="title" mat-dialog-title>
        {{
          (!isEditMode ? 'HOME.CALENDAR.CREATE_NEW_CALENDAR' : 'HOME.CALENDAR.EDIT_CALENDAR')
            | translate
        }}
      </h1>
      <button mat-mini-fab class="close-button" color="primary" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <form [formGroup]="form" class="inputs-holder">
      <mat-form-field appearance="fill" class="new-input-field">
        <input
          matInput
          type="text"
          placeholder="{{ 'HOME.CALENDAR.TITLE_PLACEHOLDER' | translate }}"
          formControlName="title"
          required
        />
        @if (form.controls.title.invalid) {
          <mat-error>{{ 'HOME.CALENDAR.TITLE_REQUIRED' | translate }} </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill" class="new-input-field">
        <input
          matInput
          type="text"
          placeholder="{{ 'HOME.CALENDAR.DESCRIPTION' | translate }}"
          formControlName="description"
        />
      </mat-form-field>
    </form>
  </div>

  <mat-dialog-content>
    <div>
      @if (employeeNames.length) {
        <h1 class="title no-padding" mat-dialog-title>
          {{ 'HOME.CALENDAR.ADDED_PEOPLE' | translate }}
        </h1>
      }
      <div class="selected-employees-container">
        @for (employee of employeeNames; track employee; let index = $index; let last = $last) {
          <section>
            <div class="employee-holder">
              <div>{{ employee }}</div>
              <mat-icon class="delete-icon" (click)="deleteEmployee(index)">delete</mat-icon>
            </div>
            <mat-divider></mat-divider>
          </section>
        }
      </div>
    </div>

    <div class="action-holder flex-columns">
      <div class="add-people-button-holder">
        <button mat-stroked-button color="primary" (click)="openAddPeopleDialog()">
          <mat-icon>add</mat-icon>
          @if (!employeeNames.length) {
            <span>{{ 'HOME.CALENDAR.ADD_PEOPLE' | translate }}</span>
          }
          @if (employeeNames.length) {
            <span>{{ 'HOME.CALENDAR.ADD_MORE_PEOPLE' | translate }}</span>
          }
        </button>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    @if (!isEditMode) {
      <button
        mat-raised-button
        color="primary"
        class="full-width"
        (click)="createCalendar()"
        [disabled]="isButtonDisabled"
      >
        <mat-icon>add</mat-icon>
        <span>{{ 'HOME.CALENDAR.CREATE_CALENDAR' | translate }}</span>
      </button>
    }

    @if (isEditMode) {
      <button
        mat-raised-button
        color="primary"
        class="full-width"
        (click)="updateCalendar()"
        [disabled]="isButtonDisabled"
      >
        <mat-icon>add</mat-icon>
        <span>{{ 'HOME.CALENDAR.UPDATE_CALENDAR' | translate }}</span>
      </button>
    }
  </mat-dialog-actions>
</div>
